<template>
  <a-row :gutter="[20, 20]" class="check-points-grid">
    <a-col
      v-for="checkPoint in checkPoints"
      :key="checkPoint.id"
      :span="12"
      @click="showForm(FORM_NAME_CHECKPOINT_EDIT, checkPoint.id)"
    >
      <check-point-card :check-point="checkPoint"/>
    </a-col>
  </a-row>

  <drawer-right v-model="isShowingDrawer" @close="onDrawerClose">
    <template v-if="FORM_NAME_CHECKPOINT_EDIT === formName">
      <edit-check-point
        :check-point="selectedCheckPoint"
        @updated="onUpdated"
        @delete-action="() => showForm(FORM_NAME_CHECKPOINT_DELETE)"
      />
    </template>
    <template v-else>
      <delete-check-point
        :check-point="selectedCheckPoint"
        @updated="onUpdated"
      />
    </template>
  </drawer-right>
</template>

<script setup>
  import CheckPointCard from '@/views/performer/components/CheckPointCard.vue';
  import { ref, watch } from 'vue';
  import { useApi } from '@/api/use-api';
  import EditCheckPoint from '@/components/projects/management/CheckPoints/EditCheckPoint.vue';
  import DeleteCheckPoint from '@/components/projects/management/CheckPoints/DeleteCheckPoint.vue';
  import DrawerRight from '@/components/drawers/components/DrawerRight.vue';
  import { FORM_NAME_CHECKPOINT_DELETE, FORM_NAME_CHECKPOINT_EDIT } from '@/components/projects/management/CheckPoints/constants/form-name';
  
  defineProps({
    checkPoints: Array,
  });

  const emit = defineEmits(['update']);

  const api = useApi();
  const selectedCheckPoint = ref(null);
  const formName = ref(null);
  const isShowingDrawer = ref(false);

  watch(formName, () => {
    isShowingDrawer.value = null !== formName.value;
  });

  const onDrawerClose = () => {
    formName.value = null;
  };

  const showForm = async (name, checkPointId = undefined) => {
    if (undefined !== checkPointId) {
      await getCheckpoint(checkPointId);
    }

    formName.value = name;
  };

  const getCheckpoint = async (id) => {
    try {
      const response = await api.performerPage.checkpoint(id);
      selectedCheckPoint.value = response.checkpoint;
    } catch (error) {
      console.error('error', error);
    }
  };
  
  const onUpdated = () => {
    formName.value = null;
    emit('update');
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .check-points-grid {
    margin-top: 30px;
    padding: 0 0 100px 0;
  }

  .horizontal-filter__panel {
    margin: 0 -40px 0 -20px;
    padding: 8px 40px 8px 20px;
    border-top: 1px solid $color-bg-secondary-grey;
    border-bottom: 1px solid $color-bg-secondary-grey;
  }
</style>
